import Chart from 'react-apexcharts';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import coverageVerificationAnalyticService from '../../../services/coverage-verification-analytics.service';

const ActivelyQueriedPlans = ({ filters }) => {
  const [activelyQueriedPlans, setActivelyQueriedPlans] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchActivelyQueriedPlans = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await coverageVerificationAnalyticService.getActivelyQueriedPlans({
            ...filters,
          });
        setActivelyQueriedPlans(data?.plans_queried || {});
      } catch (err) {
        console.error('Error fetching actively queried plans:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchActivelyQueriedPlans();
  }, [filters]);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load actively queried plans data.
      </div>
    );
  }

  if (activelyQueriedPlans.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No actively queried plan data available.
      </div>
    );
  }

  const chartOptions = {
    labels: activelyQueriedPlans.map((plan) => plan.plan),
    colors: ['#4F46E5', '#16A34A', '#F59E0B', '#06b6d4', '#f43f5e', '#facc15'],
    legend: {
      position: 'bottom',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
          labels: {
            show: true,
            name: {
              show: false,
            },
            value: {
              show: true,
              formatter: (val) => val,
            },
            total: {
              show: true,
              formatter: function (w) {
                const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                return total.toString();
              },
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  const series = activelyQueriedPlans.map((plan) => plan.count);

  return (
    <Chart options={chartOptions} series={series} type="donut" height={300} />
  );
};

export default ActivelyQueriedPlans;
